// TelegramBot i18n fragment
const fragment = {
  vi: {
    // telegramBot (list)
    'tgBot.telegramBot.title': 'Danh sách Bot Telegram',
    'tgBot.telegramBot.add': 'Thêm',
    'tgBot.telegramBot.searchLabel': 'Tìm kiếm',
    'tgBot.telegramBot.searchPlaceholder': 'Tên bot, username, channel ID...',
    'tgBot.telegramBot.reset': 'Cài lại',
    'tgBot.telegramBot.search': 'Tìm kiếm',

    // table — columns
    'tgBot.table.col.name': 'Tên Bot',
    'tgBot.table.col.username': 'Username',
    'tgBot.table.col.webhook': 'Webhook',
    'tgBot.table.col.receiveNotify': 'Nhận thông báo',
    'tgBot.table.col.createdAt': 'Ngày tạo',
    'tgBot.table.col.actions': 'Thao tác',

    // table — badges
    'tgBot.table.badge.on': 'Đang bật',
    'tgBot.table.badge.off': 'Đã tắt',
    'tgBot.table.badge.receiving': 'Đang nhận',
    'tgBot.table.badge.missingChatId': 'Thiếu Chat ID',

    // table — tooltips / aria
    'tgBot.table.tooltip.needChatId': 'Cần cập nhật Chat ID trước khi bật',
    'tgBot.table.tooltip.receivingNotify': 'Bot này đang nhận thông báo đăng bài',
    'tgBot.table.tooltip.enableToReceive': 'Bật để dùng bot này nhận thông báo',
    'tgBot.table.tooltip.sendTest': 'Gửi 1 tin test để kiểm tra cấu hình',
    'tgBot.table.tooltip.edit': 'Sửa bot',
    'tgBot.table.tooltip.delete': 'Xóa bot',
    'tgBot.table.aria.sendTest': 'Gửi test thông báo',
    'tgBot.table.aria.edit': 'Sửa bot',
    'tgBot.table.aria.delete': 'Xóa bot',

    // table — activate confirm
    'tgBot.table.activate.titleOn': 'Đặt bot nhận thông báo?',
    'tgBot.table.activate.titleOff': 'Tắt nhận thông báo?',
    'tgBot.table.activate.descOn':
      'Mọi thông báo sau khi đăng bài (Facebook Page / X) sẽ được gửi về bot này. Bot khác đang bật sẽ tự động tắt.',
    'tgBot.table.activate.descOff':
      'Sau khi tắt, hệ thống sẽ không gửi thông báo đăng bài về bất kỳ bot nào cho đến khi bạn bật lại.',
    'tgBot.table.activate.confirmOn': 'Bật',
    'tgBot.table.activate.confirmOff': 'Tắt',

    // table — webhook confirm
    'tgBot.table.webhook.title': 'Đổi trạng thái webhook?',
    'tgBot.table.webhook.desc': 'Trạng thái webhook của bot sẽ được cập nhật trên Telegram.',
    'tgBot.table.webhook.confirm': 'Đồng ý',

    // table — delete confirm
    'tgBot.table.delete.title': 'Xoá Telegram bot?',
    'tgBot.table.delete.desc':
      'Hành động này sẽ xoá bot khỏi hệ thống và gỡ webhook trên Telegram.',
    'tgBot.table.delete.confirm': 'Xoá',

    // table — empty state
    'tgBot.table.empty.title': 'Chưa có bot nào',
    'tgBot.table.empty.desc': 'Hãy thêm bot Telegram đầu tiên để bắt đầu',

    // table — toasts
    'tgBot.table.toast.testSent': 'Đã gửi test → message_id {messageId} → kiểm tra Telegram',
    'tgBot.table.toast.noActiveBot': 'Chưa có bot nào đang nhận thông báo',
    'tgBot.table.toast.missingTokenOrChatId': 'Bot active đang thiếu token hoặc Chat ID',
    'tgBot.table.toast.telegramError': 'Telegram lỗi: {description}',
    'tgBot.table.toast.telegramCallFailed': 'Gọi Telegram thất bại — xem log server',
    'tgBot.table.toast.testFailed': 'Gửi test thất bại',
    'tgBot.table.toast.missingChatIdActivate':
      'Bot chưa có Chat ID — vui lòng cập nhật trước khi bật nhận thông báo',
    'tgBot.table.toast.activated': 'Đã đặt bot nhận thông báo',
    'tgBot.table.toast.deactivated': 'Đã tắt nhận thông báo',
    'tgBot.table.toast.missingChatIdUpdate': 'Bot chưa có Chat ID — vui lòng cập nhật trước',
    'tgBot.table.toast.actionFailed': 'Thao tác thất bại',
    'tgBot.table.toast.webhookChanged': 'Đã thay đổi trạng thái webhook',
    'tgBot.table.toast.webhookChangeFailed': 'Thay đổi trạng thái thất bại',
    'tgBot.table.toast.deleteSuccess': 'Xóa bot thành công',
    'tgBot.table.toast.deleteFailed': 'Xóa bot thất bại',

    // form — title / fields / buttons
    'tgBot.form.title.create': 'Tạo Bot',
    'tgBot.form.title.update': 'Cập nhật Bot',
    'tgBot.form.field.name': 'Tên hiển thị',
    'tgBot.form.field.token': 'Token bot (lấy từ @BotFather)',
    'tgBot.form.field.chatId': 'Chat ID (nơi nhận thông báo)',
    'tgBot.form.field.chatIdPlaceholder': '123456789 hoặc -1001234567890',
    'tgBot.form.cancel': 'Hủy',
    'tgBot.form.save': 'Lưu',
    'tgBot.form.create': 'Tạo',

    // form — toasts
    'tgBot.form.toast.updateSuccess': 'Cập nhật bot thành công',
    'tgBot.form.toast.updateError': 'Cập nhật bot thất bại',
    'tgBot.form.toast.createSuccess': 'Tạo bot thành công',
    'tgBot.form.toast.invalidToken': 'Token bot không hợp lệ',
    'tgBot.form.toast.createError': 'Tạo bot thất bại',

    // form — Chat ID guide
    'tgBot.form.chatIdGuide.title': 'Hướng dẫn lấy Chat ID (nơi nhận thông báo)',
    'tgBot.form.chatIdGuide.intro':
      'Chat ID là nơi bot sẽ gửi thông báo khi đăng bài thành công/thất bại. Có thể là chat cá nhân, group hoặc channel.',
    'tgBot.form.chatIdGuide.privateLabel': 'Nhận thông báo riêng tư:',
    'tgBot.form.chatIdGuide.privatePart1': 'mở Telegram, tìm',
    'tgBot.form.chatIdGuide.privatePart2': '→ bấm',
    'tgBot.form.chatIdGuide.privatePart3': '→ bot sẽ trả về',
    'tgBot.form.chatIdGuide.privatePart4': '(vd:',
    'tgBot.form.chatIdGuide.privatePart5': 'Sau đó vào bot bạn vừa tạo, bấm',
    'tgBot.form.chatIdGuide.privatePart6': 'để bot có quyền nhắn tin cho bạn.',
    'tgBot.form.chatIdGuide.groupLabel': 'Nhận thông báo trong group:',
    'tgBot.form.chatIdGuide.groupPart1':
      'tạo group → thêm bot làm thành viên → gửi 1 tin bất kỳ → mở',
    'tgBot.form.chatIdGuide.groupPart2': '→ tìm',
    'tgBot.form.chatIdGuide.groupPart3': '(group sẽ có dạng',
    'tgBot.form.chatIdGuide.note':
      '⚠️ Nếu để trống, bot vẫn được tạo nhưng không thể nhận thông báo (active sẽ bị chặn).',

    // form — BotFather guide
    'tgBot.form.botFatherGuide.title': 'Hướng dẫn lấy Token bot (~1 phút)',
    'tgBot.form.botFatherGuide.step1Part1': 'Mở Telegram, tìm',
    'tgBot.form.botFatherGuide.step1Part2': '(tài khoản có tích xanh), hoặc bấm nút bên dưới.',
    'tgBot.form.botFatherGuide.step2Part1': 'Gửi lệnh',
    'tgBot.form.botFatherGuide.step2Part2': 'trong khung chat.',
    'tgBot.form.botFatherGuide.step3Part1': 'Nhập',
    'tgBot.form.botFatherGuide.step3Bold': 'tên hiển thị',
    'tgBot.form.botFatherGuide.step3Part2': 'cho bot (vd:',
    'tgBot.form.botFatherGuide.step4Part1': 'Nhập',
    'tgBot.form.botFatherGuide.step4Bold': 'username',
    'tgBot.form.botFatherGuide.step4Part2': 'cho bot — bắt buộc kết thúc bằng',
    'tgBot.form.botFatherGuide.step4Part3': '(vd:',
    'tgBot.form.botFatherGuide.step5': 'BotFather sẽ trả về một dòng token dạng:',
    'tgBot.form.botFatherGuide.step6Part1': 'Copy đoạn token đó và dán vào ô',
    'tgBot.form.botFatherGuide.step6Bold': '"Token bot"',
    'tgBot.form.botFatherGuide.step6Part2': 'ở trên.',
    'tgBot.form.botFatherGuide.openBtn': 'Mở @BotFather trên Telegram',
    'tgBot.form.botFatherGuide.notePart1':
      '⚠️ Token là khóa truy cập bot — đừng chia sẻ với người khác. Nếu lộ, bạn có thể gửi',
    'tgBot.form.botFatherGuide.notePart2': 'cho BotFather để cấp token mới.',
  },
  en: {
    // telegramBot (list)
    'tgBot.telegramBot.title': 'Telegram bots',
    'tgBot.telegramBot.add': 'Add',
    'tgBot.telegramBot.searchLabel': 'Search',
    'tgBot.telegramBot.searchPlaceholder': 'Bot name, username, channel ID...',
    'tgBot.telegramBot.reset': 'Reset',
    'tgBot.telegramBot.search': 'Search',

    // table — columns
    'tgBot.table.col.name': 'Bot name',
    'tgBot.table.col.username': 'Username',
    'tgBot.table.col.webhook': 'Webhook',
    'tgBot.table.col.receiveNotify': 'Notifications',
    'tgBot.table.col.createdAt': 'Created at',
    'tgBot.table.col.actions': 'Actions',

    // table — badges
    'tgBot.table.badge.on': 'On',
    'tgBot.table.badge.off': 'Off',
    'tgBot.table.badge.receiving': 'Receiving',
    'tgBot.table.badge.missingChatId': 'Missing Chat ID',

    // table — tooltips / aria
    'tgBot.table.tooltip.needChatId': 'Set a Chat ID before enabling',
    'tgBot.table.tooltip.receivingNotify': 'This bot is receiving posting notifications',
    'tgBot.table.tooltip.enableToReceive': 'Enable to use this bot for notifications',
    'tgBot.table.tooltip.sendTest': 'Send a test message to verify the setup',
    'tgBot.table.tooltip.edit': 'Edit bot',
    'tgBot.table.tooltip.delete': 'Delete bot',
    'tgBot.table.aria.sendTest': 'Send test notification',
    'tgBot.table.aria.edit': 'Edit bot',
    'tgBot.table.aria.delete': 'Delete bot',

    // table — activate confirm
    'tgBot.table.activate.titleOn': 'Set this bot to receive notifications?',
    'tgBot.table.activate.titleOff': 'Turn off notifications?',
    'tgBot.table.activate.descOn':
      'All post-publish notifications (Facebook Page / X) will be sent to this bot. Any other active bot will be turned off automatically.',
    'tgBot.table.activate.descOff':
      'Once turned off, the system will not send posting notifications to any bot until you turn it back on.',
    'tgBot.table.activate.confirmOn': 'Enable',
    'tgBot.table.activate.confirmOff': 'Disable',

    // table — webhook confirm
    'tgBot.table.webhook.title': 'Change webhook status?',
    'tgBot.table.webhook.desc': "The bot's webhook status will be updated on Telegram.",
    'tgBot.table.webhook.confirm': 'Confirm',

    // table — delete confirm
    'tgBot.table.delete.title': 'Delete Telegram bot?',
    'tgBot.table.delete.desc':
      'This will remove the bot from the system and unregister its webhook on Telegram.',
    'tgBot.table.delete.confirm': 'Delete',

    // table — empty state
    'tgBot.table.empty.title': 'No bots yet',
    'tgBot.table.empty.desc': 'Add your first Telegram bot to get started',

    // table — toasts
    'tgBot.table.toast.testSent': 'Test sent → message_id {messageId} → check Telegram',
    'tgBot.table.toast.noActiveBot': 'No bot is currently receiving notifications',
    'tgBot.table.toast.missingTokenOrChatId': 'The active bot is missing a token or Chat ID',
    'tgBot.table.toast.telegramError': 'Telegram error: {description}',
    'tgBot.table.toast.telegramCallFailed': 'Telegram call failed — check the server logs',
    'tgBot.table.toast.testFailed': 'Failed to send test',
    'tgBot.table.toast.missingChatIdActivate':
      'This bot has no Chat ID — please set one before enabling notifications',
    'tgBot.table.toast.activated': 'Bot set to receive notifications',
    'tgBot.table.toast.deactivated': 'Notifications turned off',
    'tgBot.table.toast.missingChatIdUpdate': 'This bot has no Chat ID — please set one first',
    'tgBot.table.toast.actionFailed': 'Action failed',
    'tgBot.table.toast.webhookChanged': 'Webhook status changed',
    'tgBot.table.toast.webhookChangeFailed': 'Failed to change status',
    'tgBot.table.toast.deleteSuccess': 'Bot deleted',
    'tgBot.table.toast.deleteFailed': 'Failed to delete bot',

    // form — title / fields / buttons
    'tgBot.form.title.create': 'Create bot',
    'tgBot.form.title.update': 'Update bot',
    'tgBot.form.field.name': 'Display name',
    'tgBot.form.field.token': 'Bot token (from @BotFather)',
    'tgBot.form.field.chatId': 'Chat ID (where notifications go)',
    'tgBot.form.field.chatIdPlaceholder': '123456789 or -1001234567890',
    'tgBot.form.cancel': 'Cancel',
    'tgBot.form.save': 'Save',
    'tgBot.form.create': 'Create',

    // form — toasts
    'tgBot.form.toast.updateSuccess': 'Bot updated',
    'tgBot.form.toast.updateError': 'Failed to update bot',
    'tgBot.form.toast.createSuccess': 'Bot created',
    'tgBot.form.toast.invalidToken': 'Invalid bot token',
    'tgBot.form.toast.createError': 'Failed to create bot',

    // form — Chat ID guide
    'tgBot.form.chatIdGuide.title': 'How to get a Chat ID (where notifications go)',
    'tgBot.form.chatIdGuide.intro':
      'The Chat ID is where the bot sends notifications when a post succeeds or fails. It can be a private chat, a group, or a channel.',
    'tgBot.form.chatIdGuide.privateLabel': 'Receive notifications privately:',
    'tgBot.form.chatIdGuide.privatePart1': 'open Telegram, find',
    'tgBot.form.chatIdGuide.privatePart2': '→ tap',
    'tgBot.form.chatIdGuide.privatePart3': '→ the bot returns your',
    'tgBot.form.chatIdGuide.privatePart4': '(e.g.',
    'tgBot.form.chatIdGuide.privatePart5': 'Then open the bot you just created and tap',
    'tgBot.form.chatIdGuide.privatePart6': 'so it can message you.',
    'tgBot.form.chatIdGuide.groupLabel': 'Receive notifications in a group:',
    'tgBot.form.chatIdGuide.groupPart1':
      'create a group → add the bot as a member → send any message → open',
    'tgBot.form.chatIdGuide.groupPart2': '→ find',
    'tgBot.form.chatIdGuide.groupPart3': '(groups look like',
    'tgBot.form.chatIdGuide.note':
      '⚠️ If left empty, the bot is still created but cannot receive notifications (activation will be blocked).',

    // form — BotFather guide
    'tgBot.form.botFatherGuide.title': 'How to get a bot token (~1 minute)',
    'tgBot.form.botFatherGuide.step1Part1': 'Open Telegram and find',
    'tgBot.form.botFatherGuide.step1Part2': '(the verified account), or tap the button below.',
    'tgBot.form.botFatherGuide.step2Part1': 'Send the',
    'tgBot.form.botFatherGuide.step2Part2': 'command in the chat.',
    'tgBot.form.botFatherGuide.step3Part1': 'Enter a',
    'tgBot.form.botFatherGuide.step3Bold': 'display name',
    'tgBot.form.botFatherGuide.step3Part2': 'for the bot (e.g.',
    'tgBot.form.botFatherGuide.step4Part1': 'Enter a',
    'tgBot.form.botFatherGuide.step4Bold': 'username',
    'tgBot.form.botFatherGuide.step4Part2': 'for the bot — it must end with',
    'tgBot.form.botFatherGuide.step4Part3': '(e.g.',
    'tgBot.form.botFatherGuide.step5': 'BotFather returns a token line like:',
    'tgBot.form.botFatherGuide.step6Part1': 'Copy that token and paste it into the',
    'tgBot.form.botFatherGuide.step6Bold': '"Bot token"',
    'tgBot.form.botFatherGuide.step6Part2': 'field above.',
    'tgBot.form.botFatherGuide.openBtn': 'Open @BotFather on Telegram',
    'tgBot.form.botFatherGuide.notePart1':
      '⚠️ The token is the bot access key — never share it. If leaked, send',
    'tgBot.form.botFatherGuide.notePart2': 'to BotFather to issue a new token.',
  },
};

export default fragment;
